import calls from '@/backend/api-calls'

const state = () => ({
  estimations: [],
  estimationParams: {},
  paramsLoading: false,
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    product_brand: 'Mitrex',
    project_id: null
  }
})

// getters
const getters = {
  ids: state => {
    return state.estimations.map(d => d.id);
  }
}

// actions
const actions = {
  getEstimations: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.cladifyEstimations.get(parameters)
        .then(resp => {
          commit("setEstimations", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addEstimation({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.cladifyEstimations.post(data)
        .then(resp => {
          commit("insertEstimation", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteEstimation: ({commit}, estimationId) => {
    return new Promise((resolve, reject) => {
      calls.cladifyEstimation.delete(estimationId).then(
        resp => {
          commit("removeEstimation", estimationId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Estimation successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setEstimations(state, data) {
    state.pagination = data.pagination;
    state.estimations = data.results;
  },
  insertEstimation(state, data) {
    state.estimations.push(data);
  },
  insertUpdatedEstimation(state, data) {
    state.estimations.forEach((estimations, i) => {
      if (estimations.id == data.id) {
        state.estimations.splice(i, 1, data);
      }
    })
  },
  removeEstimation(state, estimationId) {
    state.estimations.forEach((estimation, i) => {
      if (estimation.id == estimationId) {
        state.estimations.splice(i, 1);
      }
      const index = state.selected.indexOf(estimationId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}